<fieldset class="ds-beta">
  <legend i18n="Select a Contact Type | Contact Type Select Legend">Select a Contact Type</legend>

  <div *ngIf="this.availableTypes?.length < 5;then radiocontent else dropdown_content"></div>
  <ng-template #radiocontent>
    <div *ngFor="let type of this.availableTypes; let id = index" class="p-field-radiobutton">
      <p-radioButton [name]="type" [value]="type" [(ngModel)]="contactType" (onClick)="this.onValueChange($event)" [inputId]="id" [ariaLabel]="type"></p-radioButton>
      <label for="id">{{type}}</label>
    </div>
  </ng-template>
  <ng-template #dropdown_content>
    <div class="dropdown">
      <p-dropdown inputId="contactDropdown" ariaLabelledBy="contactDropdownLabel" tabindex="0" placeholder="Select" showClear="true"
        [options]="this.availableTypes" [(ngModel)]="contactType" autoDisplayFirst="false" dropdownIcon="accelicons accelicons-chevron-down"
        (onClear)="this.onValueChange($event)" (onChange)="this.onValueChange($event)" >
      </p-dropdown>
      <label class="contact-dropdown-label" for="contactDropdown" id="contactDropdownLabel" i18n="Contact Details For | Contact Type Dropdown Label">Contact Details For:</label>
  
    </div>
  </ng-template>
  
</fieldset>
